import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { CalendarioSsoModel } from 'src/app/models/calendario-sso/CalendarioSsoModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterCargaPasstModel } from 'src/app/models/interfaces/passt/IFilterCargaPasstModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { CargaPasstModel } from 'src/app/models/passt/CargaPasstModel';
import { FilterCargaPasstModel } from 'src/app/models/passt/FilterCargaPasstModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CalendarioSsoService } from 'src/app/services/calendario-sso/calendario-sso.service';
import { CargaPasstService } from 'src/app/services/carga-passt/carga-passt.service';
import { SedeService } from 'src/app/services/sede/sede.service';
import { PasstPlanificacionRegistrarDialogComponent } from '../passt-planificacion-registrar-dialog/passt-planificacion-registrar-dialog.component';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  templateUrl: './passt-planificacion-carga.component.html',
  styleUrls: ['./passt-planificacion-carga.component.css']
})
export class PasstPlanificacionCargaComponent implements OnInit {
  model: IFilterCargaPasstModel;
  displayedColumnsAccidente: string[] = ['anio', 'compania', 'sede', 'archivo', 'fechaCreacion', 'estado', 'detalle'];
  listaCargas: CargaPasstModel[] = new Array<CargaPasstModel>();
  listaSedes: ISedeModel[] = new Array<SedeModel>();
  listaAnios: Number[];
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  resultsLength = 0;
  currentPage = 0;
  
  @ViewChild('paginator') paginator!: MatPaginator;
  
  constructor(
    public dialog: MatDialog,
    private calendarioService: CalendarioSsoService,
    private alertDialogService: AlertDialogService,
    private sedeService: SedeService,
    private service: CargaPasstService,
    private storage: StorageService) { 
      this.model = new FilterCargaPasstModel();
      this.listaAnios = new Array<number>();
      let usuario = this.storage.getCurrentUser();
      this.listaCompanias = usuario.companias;
      this.model.idCompania = usuario.companiaDefault.idCompania;
    }

  ngOnInit(): void {
    
      
    this.calendarioService.getAnios()
      .subscribe((data: number[]) => {
        this.listaAnios = data;
      });
      this.calendarioService.getCurrent(this.model.idCompania)
      .subscribe((data: CalendarioSsoModel) => {
        if(data.mes>0){
          this.model.anio = data.anio;
        }
      });
      this.companiaChanged();
      this.search();
  }

  companiaChanged() {

    this.listaSedes = [];
    this.model.sedes = [];
    let filterSede: IFilterSedeModel = new FilterSedeModel();
    filterSede.companias.push(this.model.idCompania);

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
      });
  }

  search() {
    //this.paginator.pageIndex = 0;
    this.model.page = 1;
    this.model.pageSize = 30;
    this.service
      .getList(this.model)
      .subscribe((data: SearchResultModel<CargaPasstModel[]>) => {
        this.listaCargas = data.items;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  getPaginatorData(event: any) {
    this.model.page = event.pageIndex + 1;
    this.model.pageSize = event.pageSize;
    // this.serviceSede
    //   .getListFiltered(this.filter)
    //   .subscribe((data) => {
    //     this.model = data;
    //     this.resultsLength = data.total;
    //   });
  }

  registrarArchivo(): void{
    const dialogRef = this.dialog.open(PasstPlanificacionRegistrarDialogComponent, {
      width: '1000px',
    });  
    dialogRef.afterClosed().subscribe((result: CargaPasstModel) => {
      if(result)
        this.search();
    });
  }

}